import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { StoryBlocksContainerModule } from "@hermes/fragments/chapters";

import { StoryPageComponent } from "./components/story-page/story-page.component";
import { StoryPageRoutingModule } from "./story-page-routing.module";

@NgModule({
    imports: [CommonModule, StoryBlocksContainerModule, StoryPageRoutingModule],
    declarations: [StoryPageComponent],
})
export class StoryPageModule {}
